"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.realUserMonitoringReduxMiddleware = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Redux middleware that allows seamless integration of Datadog RUM events with redux actions.
 *
 * It tracks actions that have an 'analytics' object inside the 'meta' object of the action
 *
 * @return {function} Result from next steps of the middleware
 *
 * @example
 * Use it with the configureStore helper to add it to the middleware of the app:
 *
 * this._store = configureStore({
 *     reducer,
 *     initialState: {},
 *     middleware: [datadogRealUserMonitoringMiddleware()],
 * });
 *
 * If you would like to add some (default) props globally to your app, provide a
 * getDefaults arg to the middleware:
 *
 * datadogRealUserMonitoringMiddleware((state) => ({
 *     category: 'myGACat',
 *     dimensions: {
 *         sessionId: state.sessionId,
 *     },
 * })
 *
 * Then simply dispatch an action with `meta.analytics` information:
 *
 * dispatch({
 *     type: MY_ACTION,
 *     payload: {...},
 *     meta: {
 *         analytics: {
 *             action: MY_ACTION_GA_ACTION,
 *             category: MY_ACTION_CATEGORY,
 *             label: A_LABEL,
 *             dimensions: {
 *                 isFirstOrder: true,
 *             },
 *         }
 *     }
 * });
 *
 * Only `action` and `category` are required. The user and event dimensions will be populated automatically
 * from the state, if available.
 */
var realUserMonitoringReduxMiddleware = function realUserMonitoringReduxMiddleware() {
  var getDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return {};
  };
  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        var result = next(action);
        var siteAnalyticsAction = action; // We have to ignore any non-analytics action

        if (!siteAnalyticsAction.meta || !siteAnalyticsAction.meta.analytics) {
          return result;
        }

        var state = getState();
        var defaults = getDefaults(state);

        var payload = _objectSpread(_objectSpread(_objectSpread({}, defaults), siteAnalyticsAction.meta.analytics), {}, {
          dimensions: _objectSpread(_objectSpread({}, defaults.dimensions || {}), siteAnalyticsAction.meta.analytics.dimensions || {})
        });

        if (typeof window !== 'undefined' && window.DD_RUM && window.DD_RUM.addAction) {
          window.DD_RUM.addAction(payload.action, payload);
        }

        return result;
      };
    };
  };
};

exports.realUserMonitoringReduxMiddleware = realUserMonitoringReduxMiddleware;
//# sourceMappingURL=redux-middleware.js.map